import { FC, useState } from "react";
import { useLocation } from "react-router-dom";
import { Box } from "@mui/material";
import Logo from "../../Images/AppBar/byd-logo-white-c.png";
import { useTranslation } from "react-i18next";
import { getCurrentLanguage } from "../../utils/languageUtils";
import CarModelsMenu from "./CarModelsMenu/CarModelsMenu";
import LanguageMenu from "./LanguageMenu/LanguageMenu";
import CloseIcon from "@mui/icons-material/Close";
import MenuIcon from "@mui/icons-material/Menu";
import MobileMenu from "./MobileMenu/MobileMenu";
import { buttons, headerHeight } from "./hardCodeData";
import LanguageAwareNavLink from "../../components/LanguageAwareNavLink";
// import languageIcon from "../../Images/AppBar/language_icon.svg"
import "./style.css";

const Header: FC = () => {
  const { t } = useTranslation();
  const pathName = useLocation();
  const [openMenu, setOpenMenu] = useState({
    language: false,
    carModels: false,
  });

  const [openMobileMenu, setOpenMobileMenu] = useState(false);

  const toggleDrawer = (newOpen: boolean) => () => {
    setOpenMobileMenu(newOpen);
  };

  return (
    <Box>
      <Box
        sx={{
          position: "fixed",
          width: "100%",
          height: headerHeight,
          background: "#252728",
          color: "#fff",
          display: "flex",
          alignItems: "center",
          zIndex: 3,
        }}
      >
        <Box
          sx={{
            pl: { xs: 2, lg: 5 },
            width: { xs: "50%", lg: "17.5%" },
          }}
        >
          <LanguageAwareNavLink onClick={() => toggleDrawer(false)} to="/">
            <img alt="BYD" src={Logo} width={1359 / 14} height={404 / 14} />
          </LanguageAwareNavLink>
        </Box>
        <Box
          sx={{
            display: { xs: "none", lg: "flex" },
            width: "65%",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {buttons.map((button, i) => {
            const models = button.name === "BYD";
            return (
              <LanguageAwareNavLink
                className="NavButtons"
                style={{
                  height: openMenu.carModels && models ? headerHeight : "100%",
                }}
                to={models ? pathName.pathname : button.path}
                key={i}
                onMouseEnter={() => {
                  if (models) {
                    setOpenMenu((prev) => ({
                      ...prev,
                      carModels: true,
                    }));
                  }
                }}
                onMouseOut={() => {
                  if (models) {
                    setOpenMenu((prev) => ({
                      ...prev,
                      carModels: false,
                    }));
                  }
                }}
              >
                {t(`common:${button.name}`)}
              </LanguageAwareNavLink>
            );
          })}
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "end",
            pr: { xs: 2, lg: 5 },
            width: { xs: "50%", lg: "17.5%" },
          }}
        >
          <Box
            onMouseEnter={() =>
              setOpenMenu((prev) => ({
                ...prev,
                language: true,
              }))
            }
            onMouseOut={() =>
              setOpenMenu((prev) => ({
                ...prev,
                language: false,
              }))
            }
            sx={{
              display: { xs: "none", lg: "flex" },
              alignItems: "center",
              textTransform: "capitalize",
              fontWeight: 500,
              cursor: "pointer",
              "&:hover": { height: headerHeight },
            }}
          >
            {/* <img alt="language" src={languageIcon}/> */}
            {getCurrentLanguage().toUpperCase()}
          </Box>
          <Box
            sx={{
              display: { xs: "flex", lg: "none" },
              "&:hover": { cursor: "pointer" },
            }}
          >
            {openMobileMenu ? (
              <CloseIcon onClick={toggleDrawer(!openMobileMenu)} />
            ) : (
              <MenuIcon onClick={toggleDrawer(!openMobileMenu)} />
            )}
          </Box>
        </Box>
      </Box>

      <LanguageMenu headerHeight={headerHeight} openMenu={openMenu} />
      <CarModelsMenu headerHeight={headerHeight} openMenu={openMenu} />
      <MobileMenu openMobileMenu={openMobileMenu} toggleDrawer={toggleDrawer} />
    </Box>
  );
};

export default Header;
